import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpHeaderResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { ConfigurationService } from './configuration.service';


@Injectable({ providedIn: 'root'})
export class EndpointFactory {
  static readonly apiVersion: string = '1';
  private readonly _loginUrl: string = '/connect/token';
  private readonly _getTeamsUrl: string = '/api/team/getbyuser';
  private _authService: AuthService;

  private get authService() {
    if (!this._authService)
      this._authService = this.injector.get(AuthService);

    return this._authService;
  }

  get loginUrl() { return this.configurations.baseUrl + this._loginUrl; }

  get getTeamsUrl() { return this.configurations.baseUrl + this._getTeamsUrl; }

  constructor(
    protected http: HttpClient,
    protected configurations: ConfigurationService,
    private injector: Injector) {}

  getUserTeamsEndpoint<T>(userId: string, roleId: string, projectId: string): Observable<T> {
    const endpointUrl = `${this.getTeamsUrl}/${userId}/${roleId}/${projectId}`;
    console.log(`Calling http get on ${endpointUrl}`);
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  getLoginEndpoint<T>(userName: string, password: string): Observable<T> {

    let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let params = new HttpParams()
      .append('username', userName)
      .append('password', password)
      .append('grant_type', 'password')
      .append('scope', 'openid email phone profile offline_access roles');

    let requestBody = params.toString();
    return this.http.post<T>(this.loginUrl, requestBody, { headers: header });
  }

  getRefreshLoginEndpoint<T>(): Observable<T> {

    let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let params = new HttpParams()
      .append('refresh_token', this.authService.refreshToken)
      .append('grant_type', 'refresh_token')
      .append('scope', 'openid email phone profile offline_access roles');

    let requestBody = params.toString();

    return this.http.post<T>(this.loginUrl, requestBody, { headers: header });
  }

  protected getRequestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/json',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion
    });

    return { headers: headers };
  }

  protected getUploadHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion
    });

    return { headers: headers };
  }

  protected DecodeArrayBuffer(array: ArrayBuffer) {
    return window.hasOwnProperty('TextDecoder')
      ? (new TextDecoder()).decode(array)
      : this.Utf8ArrayToStr(new Uint8Array(array));
  }

  // Solution for Edge not supporting TextDecoder (https://stackoverflow.com/a/22373197).
  private Utf8ArrayToStr(array: Uint8Array): string {
    let out: string, i: number, len: number, c: number;
    let char2: number, char3: number;

    out = '';
    len = array.length;
    i = 0;
    while (i < len) {
      c = array[i++];
      switch (c >> 4) {
        case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
          // 0xxxxxxx
          out += String.fromCharCode(c);
          break;
        case 12: case 13:
          // 110x xxxx   10xx xxxx
          char2 = array[i++];
          out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));
          break;
        case 14:
          // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = array[i++];
          char3 = array[i++];
          out += String.fromCharCode(((c & 0x0F) << 12) | ((char2 & 0x3F) << 6) | ((char3 & 0x3F) << 0));
          break;
      }
    }

    return out;
  }
}
